import { createReducer, on } from '@ngrx/store';
import { SchemaActions } from '../actions';
import { SchemaState } from '../state/schema.state';

export const initialSchemaState: SchemaState = {
  schema: null,
  schemaVersion: null,
};

export const schemaReducer = createReducer(
  initialSchemaState,
  on(SchemaActions.schemaLoaded, (state, action): SchemaState => ({ ...state, schema: action.schema, schemaVersion: action.version })),
  on(SchemaActions.resetSchemaState, (state): SchemaState => ({ ...state, ...initialSchemaState }))
);
